import { axiosInstance } from "./axiosSetup";
import { handleErrors } from "./handleErrors";

// eslint-disable-next-line import/prefer-default-export
export async function getGraphData() {
  return axiosInstance.get(`tracker/dashboard`).catch(handleErrors);
}

export const getDashboardTracker = async () => axiosInstance.get(`tracker/metadata`).catch(handleErrors)

export const getDashboardKpis = async () => axiosInstance.get(`tracker/kpis`).catch(handleErrors)

export const getRorMatchingReport = async () => axiosInstance.get(`tracker/reports/ror-matching`).catch(handleErrors)
